import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

const links = [
  { to: "/gallery/landscapes", label: "Landscapes" },
  { to: "/gallery/buildings-and-barns", label: "Barns" },
  { to: "/gallery/bins-and-equipment", label: "Equipment" },
  { to: "/gallery/pickup-trucks", label: "Trucks" },
  { to: "/gallery/wildlife-and-animals", label: "Wildlife" },
  { to: "/gallery/a-little-bit-vintage", label: "Vintage" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const navigate = useNavigate();
  const { totalQty, setOpen: setCartOpen } = useCart();

  const goAbout = (e) => {
    e.preventDefault();
    if (loc.pathname === "/") {
      document.getElementById("story")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: "story" } });
    }
  };
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-9 left-0 right-0 z-50 backdrop-blur-xl bg-paper/80 border-b transition-colors duration-500 ${scrolled ? "border-line" : "border-transparent"}`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src="/logo.jpg" alt="Prairie Prints MT" className="h-12 w-12 rounded-full object-cover mix-blend-multiply" />
          <span className="flex flex-col leading-none">
            <span className="font-serif text-2xl tracking-tight">Prairie Prints</span>
            <span className="label text-stone -mt-0.5">Northeast Montana</span>
          </span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className="label text-ink hover:text-brick transition-colors duration-300">
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <a href="/#story" data-testid="nav-about" onClick={goAbout} className="hidden md:inline-block label text-ink hover:text-brick transition-colors duration-300 cursor-pointer">About</a>
          <button data-testid="cart-button" onClick={() => setCartOpen(true)}
            className="relative label flex items-center gap-2 text-ink hover:text-brick transition-colors duration-300">
            <ShoppingBag size={18} />
            <span className="hidden sm:inline">Cart</span>
            {totalQty > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-3 bg-brick text-paper w-5 h-5 flex items-center justify-center rounded-full text-[10px] font-sans">{totalQty}</span>
            )}
          </button>
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}
            className="lg:hidden label border border-line px-4 py-2">{open ? "Close" : "Menu"}</button>
        </div>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-paper border-t border-line px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} className="label text-ink">{l.label}</Link>
          ))}
        </div>
      )}
    </header>
  );
};
